import { Image } from "react-bootstrap";

const CarouselItem = ({
    src,
    ariaLabel,
    alt,
    onClick = () => {},
    className = ""
}) => {
    if (!src) throw new Error("src is required");
    return (
    <div
        onClick={onClick}
        style={{ cursor: "pointer"}}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            onClick();
          }
        }}
        aria-label={ariaLabel}
        tabIndex={"0"}
      >
        <Image style={{ width: "100%", height: "auto" }} className={className} src={src} alt={alt} />
      </div>
    )
}


export default CarouselItem;